import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg, img, uploadFile } from "../../lib/api";

export const ImageUpload = ({ value, onChange, testid, aspect = "aspect-video", fit = "object-cover" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      onChange(await uploadFile(f));
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <button type="button" onClick={() => ref.current?.click()} className={`relative grid w-full place-items-center overflow-hidden rounded-2xl border-2 border-dashed bg-[var(--cream)] text-sm text-[var(--ink)]/60 transition-colors hover:border-[var(--forest)] ${aspect}`} data-testid={testid}>
      {value ? <img src={img(value)} alt="" className={`absolute inset-0 h-full w-full ${fit}`} /> : null}
      <span className={`relative flex items-center gap-2 rounded-full px-4 py-2 ${value ? "bg-white/90" : ""}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}
        {busy ? "Mengunggah..." : value ? "Ganti gambar" : "Unggah gambar (maks 5MB)"}
      </span>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </button>
  );
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-2 block text-sm font-medium text-[var(--ink)]">{label}</span>
    {children}
  </label>
);
